<div class="modal-header">
  <h4 class="modal-title">Selección de Impresora</h4>
  <button type="button" class="btn-close" aria-label="Close" (click)="close(false)"></button>
</div>
<form #form="ngForm">
  <div class="modal-body">

    <div class="row mb-3">
      <div class="col">
        Seleccione las impresoras a utilizar en esta computadora. Estas impresoras se utilizarán por defecto para
        imprimir las guías y etiquetas. Si no selecciona una impresora, se le pedirá que seleccione una cada vez que
        intente imprimir.
      </div>
    </div>
    <div class="row mb-3">
      <div class="col">
        <div class="">
          <label for="etiquetaPrinter" class="form-label "
            [class.required]="etiquetaPrinterRequired()">Etiquetas</label>
          <app-select name="etiquetaPrinter" id="etiquetaPrinter" [required]="etiquetaPrinterRequired()"

            [clearable]="false"
            [items]="printers.value() || []" bindLabel="nombre" bindValue="nombre"
            [notFoundText]="'No se encontraron impresoras'"
            [(ngModel)]="etiquetaPrinter ">
          </app-select>

        </div>
      </div>
    </div>

    <div class="row mb-3">
      <div class="col">
        <div class="">
          <label for="guiaPrinter" class="form-label " [class.required]="guiaPrinterRequired()">Guías</label>
          <app-select name="guiaPrinter" id="guiaPrinter" [required]="guiaPrinterRequired()"

            [clearable]="false"
            [items]="printers.value() || []" bindLabel="nombre" bindValue="nombre"
            [notFoundText]="'No se encontraron impresoras'"
            [(ngModel)]="guiaPrinter ">
          </app-select>

        </div>
      </div>
    </div>

    <div class="row mb-3">
      <div class="col">
        <div class="">
          <label for="defaultPrinter" class="form-label "
            [class.required]="defaultPrinterRequired()">Predeterminada</label>
          <app-select name="defaultPrinter" id="defaultPrinter" [required]="defaultPrinterRequired()"

            [clearable]="false"
            [items]="printers.value() || []" bindLabel="nombre" bindValue="nombre"
            [notFoundText]="'No se encontraron impresoras'"
            [(ngModel)]="defaultPrinter ">
          </app-select>

        </div>
      </div>
    </div>

  </div>
  <div class="modal-footer">
    <button type="submit" class="btn btn-primary" [disabled]="form.invalid" (click)="close(true)">Aceptar</button>
    <button type="button" class="btn btn-outline-secondary" (click)="close(false)">Cancelar</button>
  </div>
</form>